var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 42,
    viewBox: "0 0 62 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 61,
    height: 41,
    rx: 5.5,
    fill: "white",
    stroke: "#ECEDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9778 15.9961L26.2124 26.26H29.0358L30.8027 15.9961H27.9778Z",
    fill: "#1565C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8425 16.0061L21.0772 23.0058L20.7824 21.9489C20.237 20.6754 18.6887 18.8465 16.8711 17.6939L19.3997 26.2534L22.3872 26.2484L26.8337 16.0039L23.8425 16.0061Z",
    fill: "#1565C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7113 16.7401C19.5472 16.1149 19.0716 15.9286 18.4812 15.9062H14.1037L14.0674 16.1106C17.4739 16.9293 19.728 18.9021 20.6634 21.2742L19.7113 16.7401Z",
    fill: "#1565C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5237 17.9624C37.4474 17.948 38.1169 18.148 38.6369 18.3552L38.8918 18.4739L39.2737 16.2493C38.7146 16.0414 37.8381 15.8184 36.7444 15.8184C33.9544 15.8184 31.9879 17.2105 31.9726 19.2056C31.9545 20.6798 33.3734 21.5029 34.4453 21.9943C35.5455 22.4979 35.9144 22.818 35.9093 23.2677C35.9006 23.9548 35.0321 24.2699 34.2209 24.2699C33.0902 24.2699 32.4897 24.1152 31.5623 23.7325L31.1985 23.5685L30.8013 25.8657C31.4621 26.1528 32.6814 26.3996 33.9471 26.4125C36.9151 26.4125 38.8438 25.0369 38.8642 22.9051C38.8765 21.7388 38.1234 20.8489 36.4917 20.1186C35.5041 19.6423 34.8999 19.3258 34.9057 18.8452C34.9057 18.4185 35.4184 17.9624 36.5237 17.9624Z",
    fill: "#1565C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5225 16.0059H44.341C43.6634 16.0059 43.1595 16.1886 42.8617 16.8577L38.6694 26.264H41.6345C41.6345 26.264 42.1181 24.9992 42.2278 24.7222C42.5524 24.7222 45.4332 24.7265 45.8435 24.7265C45.9277 25.0848 46.1877 26.264 46.1877 26.264H48.8071L46.5225 16.0059ZM43.0404 22.6214C43.2728 22.0321 44.1652 19.7528 44.1652 19.7528C44.15 19.7809 44.3954 19.1593 44.5414 18.7729L44.7317 19.6579C44.7317 19.6579 45.2727 22.1084 45.386 22.6214H43.0404Z",
    fill: "#1565C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61 36C61 38.7614 58.7614 41 56 41L6 41C3.23857 41 1 38.7614 1 36V33L61 33V36Z",
    fill: "#FCD735"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 6C1 3.23858 3.23858 1 6 1L56 1.00001C58.7614 1.00001 61 3.23859 61 6.00001L61 9.00001L0.999999 9L0.999999 6Z",
    fill: "#1E88E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.fdb929cd93f0d2e3e366789ecb08a9bf.svg";
export { ForwardRef as ReactComponent };